<script>
import { shippingMethodLcProps, useShippingMethodLc } from "./mixin";

import AddressLadSelector from "@/containers/adresses-lad/adress-lad-selector";
import Planning from "@/containers/planning";
import AddressLadForm from "@/containers/adresses-lad/addresse-lad-form";
import Popin from "@/components/molecules/popin";
import LazyImage from "@/components/atoms/lazy-image";
import FormRadio from "@/components/molecules/form-radio";
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import Button from "@/components/atoms/button";
import InfosService from "./infos-service";

export default {
  name: "ShippingMethodLc",
  components: {
    AddressLadSelector,
    Planning,
    AddressLadForm,
    Popin,
    LazyImage,
    FormRadio,
    Titre,
    Divider,
    InfosService,
    Button
  },
  props: {
    ...shippingMethodLcProps()
  },
  emits: ["openPopinTarifsYper"],
  setup(props) {
    const raisonsIndispo = ref(null);
    const {
      serviceSelectedId,
      serviceModel,
      raisonsImpossible,
      partenaires,
      selectedService,
      mounted,
      resetService,
      isServiceDisabled,
      getTarifMini,
      showRaisonsIndispo
    } = useShippingMethodLc(props, raisonsIndispo);

    onMounted(mounted);
    return {
      raisonsIndispo,
      serviceSelectedId,
      serviceModel,
      raisonsImpossible,
      partenaires,
      selectedService,
      resetService,
      isServiceDisabled,
      getTarifMini,
      showRaisonsIndispo
    };
  },
  data() {
    return {
      addresseId: null
    };
  },
  methods: {
    showAddAdress() {
      this.$refs.popinAddAddress.show();
    },
    editAddress(id) {
      this.addresseId = id;
      this.$refs.popinAddAddress.show();
    },
    addresseLadSaved() {
      this.$refs.addressLadSelector.refresh();
      this.$refs.popinAddAddress.hide();
    }
  },
  watch: {
    selectedService: {
      handler(val) {
        this.serviceModel = val;
      },
      immediate: true
    }
  }
};
</script>

<template>
  <div class="u-pt-sm u-pl-md u-pr-md u-pb-md">
    <AddressLadSelector
      ref="addressLadSelector"
      :check-eligibilite="false"
      @addAddress="showAddAdress()"
      @editAddress="editAddress"
    />

    <template v-if="addresseLad">
      <div class="u-flex u-flex-align-center u-my-md">
        <Titre
          tag="h2"
          size="xs"
        >
          Service de livraison
        </Titre>
        <Divider
          class="u-flex-item-fluid u-ml-xs"
          dotted
        />
      </div>
      <template v-if="partenaires.length > 1">
        <p class="u-mb-lg u-ml-md">
          Merci de sélectionner un de nos partenaires de livraison collaborative
        </p>
        <div class="u-block@lg u-flex u-flex-justify-center">
          <div
            v-for="p in partenaires"
            :key="p.description"
            class="u-ml-sm u-mr-sm u-mb-sm"
          >
            <FormRadio
              v-model="serviceSelectedId"
              :value="p.id"
              :disabled="isServiceDisabled(p)"
              name="partenaire"
              block
            >
              <LazyImage
                :src="p.image_url"
                :alt="p.description"
                dimension="100"
                width="80"
                height="80"
              />
              <div class="u-ml-sm u-mr-md u-flex-item-fluid c-shipping-method-lc__text-container">
                <p class="u-font-700">
                  {{ p.description }}
                </p>
                <p class="u-color-primary">
                  {{ getTarifMini(p) }}
                </p>
                <p v-if="isServiceDisabled(p)">
                  <Button
                    link
                    @click="showRaisonsIndispo(p)"
                  >
                    <span class="u-font-13 u-color-text">
                      Pourquoi est-il indisponible ?
                    </span>
                  </Button>
                </p>
              </div>
            </FormRadio>
          </div>
        </div>
      </template>
      <template v-if="serviceModel">
        <div class="u-color-text-light u-font-14 u-mx-md@md u-mx-xlg u-flex">
          <LazyImage
            v-if="partenaires.length == 1"
            :src="serviceModel.image_url"
            :alt="serviceModel.description"
            dimension="100"
            width="80"
            height="80"
            class="u-mr-md"
          />
          <div class="u-flex-item-fluid">
            <InfosService
              :service="serviceModel"
              :tarif-mini="getTarifMini(serviceModel)"
              @openPopinTarifsYper="$emit('openPopinTarifsYper')"
            />
          </div>
        </div>
        <div class="u-flex u-flex-align-center u-mt-md">
          <Titre
            tag="h2"
            size="xs"
          >
            Créneau horaire
          </Titre>
          <Divider
            class="u-flex-item-fluid u-ml-xs"
            dotted
          />
        </div>
        <p class="u-mt-md u-mb-lg u-ml-md">
          Merci de préciser le créneau horaire auquel vous souhaitez retirer vos produits
        </p>
        <Planning
          :service-id="serviceModel.id"
          :infos-legales="serviceModel.info_non_retrait"
          creneaux-full-width
        />
      </template>
    </template>
    <Popin
      ref="popinAddAddress"
      aria-label="Adresse de livraison"
      size="lg"
      @hidden="addresseId = null"
    >
      <h1 class="u-font-24 u-text-center u-color-primary u-mb-lg u-mb-none@sm u-p-sm@sm">
        <template v-if="!addresseId">
          Ajouter
        </template><template v-else>
          Modifier
        </template> une adresse de livraison
      </h1>
      <AddressLadForm
        :addresse-id="addresseId"
        :check-eligibilite="false"
        @cancel="$refs.popinAddAddress.hide()"
        @saved="addresseLadSaved()"
      />
    </Popin>
    <Popin
      ref="raisonsIndispo"
      aria-label="Raisons de l'impossibilité"
    >
      <p
        v-for="(raison, index) in raisonsImpossible"
        :key="`raison-${raison.type_raison}-${index}`"
        class="u-font-14 u-mb-xs u-mt-xs"
      >
        {{ raison.raison }}
      </p>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/schedule.scss";

.c-shipping-method-lc__text-container {
  line-height: 140%;
}
</style>
